define.alias("shared/components/shared/pre-boarding/sourceless-trial-end/index", "settings/components/shared/pre-boarding/sourceless-trial-end/index");